import { createMuiTheme } from '@material-ui/core/styles';

export const defaultTheme = createMuiTheme({
});


